module.exports = __webpack_public_path__ + "static/img/n4-2.4c5006a6.jpg";